module.exports = __webpack_public_path__ + "shareLink.svg?7997fe8345debe4b485018039be55f06";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/shareLink.svg
// module id = 616
// module chunks = 2